<template>
  <div id="layout-wrapper">
    <div id="layout-body">
      <div class="game-component">
        <div class="frame-grid">
          <div class="grid-header" />
          <!-- <div class="grid-sidebar"></div> -->
          <div class="grid-content">
            <div id="game-wrapper">
              <div
                v-if="text!==''"
                ref="newsTicker"
                class="news-ticker-frame"
                :class="{ active: isNewsTickerActive }"
                :style="newsTickerStyle"
              >
                <div class="icon-news-ticker">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-news-w.png`)">
                </div>
                <div class="news-content">
                  <span ref="scrollingText" class="scrolling-text">{{ text }}</span>
                </div>
                <div class="icon-expand" @click="toggleNewsTickerActive" />
              </div>
              <iframe id="iframebox" ref="gameIframe" :src="gameUrlFromStore" />
            </div>
          </div>
          <div class="grid-footer">
            <div class="game-menu">
              <div class="game-buttons">
                <!-- MENU -->
                <div v-if="!isFromKYCVerify" class="game-menu-item gm-btn-1 link-item" @click="toggleDrawer('wallet')">
                  <div class="game-menu-item-icon">
                    <img :src="require(`@/assets/${$store.getters.currentTheme}/images/wallet.png`)" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.menu') }}</span>
                  </div>

                  <!-- drawer Start -->

                  <div v-if="isWalletDrawerOpen" class="drawer">
                    <div class="drawer-frame">
                      <div class="drawer-grid amount-box">
                        <div class="drawer-wallet-title">
                          {{ $t('Bao.main_gold') }}
                        </div>
                        <hr class="seperation">
                        <div class="value-box">
                          {{ $store.state.brand.currency }}{{ $store.getters.mainGold | numberFormat }}
                        </div>
                      </div>
                      <div class="drawer-grid bonus-box">
                        <div class="drawer-wallet-title">
                          {{ $t('Bao.bonus_gold') }}
                        </div>
                        <hr class="seperation">
                        <div class="value-box">
                          {{ $store.state.brand.currency }}{{ $store.getters.bonusGold | numberFormat }}
                        </div>
                      </div>
                      <div class="drawer-grid drawer-close-btn">
                        <div class="drawer-wallet-close">
                          <div class="dw-btn-close" href="javascript:;">
                            &#10005;
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- drawer-wallet End -->
                </div>

                <!-- PLAYED GAMES -->
                <div v-if="!isFromKYCVerify" class="game-menu-item gm-btn-2 link-item ">
                  <div class="game-menu-item-icon" @click="toggleDrawer('history')">
                    <img :src="require(`@/assets/${$store.getters.currentTheme}/images/history.png`)" alt="">
                  </div>
                  <div class="game-menu-item-text" @click="toggleDrawer('history')">
                    <span class="btn-text">{{ $t('Bao.record') }}</span>
                  </div>

                  <!-- drawer Start -->

                  <div v-if="isHistoryDrawerOpen" class="drawer">
                    <div class="drawer-frame">
                      <div class="gameframe-card-background">
                        <div class="iframe-game-arrow side-previous" @click="scrollGameCardList('left')">
                          &#x276E;
                        </div>
                        <div class="iframe-game-arrow side-next" @click="scrollGameCardList('right')">
                          &#x276F;
                        </div>
                        <div class="iframe-game-arrow drawer-close" @click="isHistoryDrawerOpen=false">
                          &#10005;
                        </div>
                        <div class="drawer-2-title">
                          <span class="title-text">{{ $t('Bao.record') }}</span>
                        </div>
                        <div ref="gameCardList" class="gameframe-card-list">
                          <div v-for="(game, key) in filterResult.slice(0, 40) " :key="key" class="gameframe-card" :class="{ active: game.showDetail }">
                            <div class="gameframe-card-image" @click="handleLaunchGame(game)">
                              <picture>
                                <img
                                  :src="game.image"
                                  alt="Game Record Images"
                                >
                              </picture>
                            </div>

                            <i class="game-info-icon" />

                            <div class="gameframe-card-name">
                              <i class="game-info-icon" @click="triggerDetail(game)" />
                              <span class="game-name" @click="handleLaunchGame(game)">{{ game.name }}</span>
                              <span class="game-provider">{{ game.game_provider_name }}</span>
                            </div>
                            <div class="gameframe-card-info">
                              <div class="close" @click="triggerDetail(game)">
                                ✕
                              </div>
                              <span v-show="game.rtp!==-1">{{ $t("Bao.rtp") }}：</span>
                              <span v-show="game.rtp!==-1">{{ (game.rtp * 100).toFixed(2) }}%</span>  <!-- 將小數點轉化為百分比，取值至小數點後兩位 -->
                              <span v-show="game.yesterday_rtp!==-1">{{ $t("Bao.rtp_yesterday") }}：</span>
                              <span v-show="game.yesterday_rtp!==-1">{{ game.yesterday_rtp }}%</span>
                              <span>{{ $t("Bao.bet_range") }}：</span>
                              <span>{{ $store.state.brand.currency }}{{ game.bet_amount_range.split('~')[0] }} - {{ $store.state.brand.currency }}{{ game.bet_amount_range.split('~')[1] }}</span>
                              <span v-show="game.max_odds!==-1">{{ $t("Bao.max_odds") }}：</span>
                              <span v-show="game.max_odds!==-1">{{ game.max_odds }}</span>
                              <button @click="handleLaunchGame(game)">
                                <span>{{ $t("Bao.play_game_now") }}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- drawer-wallet End -->
                </div>

                <!-- DEPOSIT-->
                <div v-if="!isFromKYCVerify" class="game-menu-item gm-btn-3 link-item" @click="toggleDrawer('deposit')">
                  <div class="game-menu-item-icon">
                    <img :src="require(`@/assets/${$store.getters.currentTheme}/images/top_up.png`)" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.deposit') }}</span>
                  </div>

                  <!-- drawer Start -->
                  <div v-if="isDepositDrawerOpen" class="drawer">
                    <div class="drawer-frame">
                      <div class="drawer-deposit">
                        <h6 class="deposit-subtitle">
                          {{ $t('Bao.deposit') }}
                        </h6>
                      </div>
                      <div class="drawer-deposit">
                        <p class="deposit-text">
                          {{ $t('Bao.deposit_quick') }}
                        </p>
                      </div>
                      <div class="drawer-deposit w-100" @click="handleDepositClick">
                        <button class="drawer-deposit-btn btn-deposit">
                          {{ $t('Bao.deposit_action') }}
                        </button>
                      </div>
                      <div class="drawer-deposit w-100">
                        <button class="drawer-deposit-btn btn-closed">
                          {{ $t('Bao.close') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- drawer End -->
                </div>

                <!-- ADD FAVORITES -->
                <div v-if="!isFromKYCVerify" class="game-menu-item link-item" @click.stop="handleFavoriteGame($store.state.app.currentGame)">
                  <div class="game-menu-item-icon" :class="{ active:$store.state.app.currentGame.isFavorite }">
                    <img :src="require(`@/assets/${$store.getters.currentTheme}/images/collect.png`)" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span v-if="$store.state.app.currentGame.isFavorite" class="btn-text"> {{ $t('Bao.remove_fav') }}</span>
                    <span v-if="!$store.state.app.currentGame.isFavorite" class="btn-text"> {{ $t('Bao.add_fav') }}</span>
                  </div>
                </div>

                <!-- EXIT -->
                <div class="game-menu-item link-item" @click="clearGameUrl">
                  <div class="game-menu-item-icon">
                    <img :src="require(`@/assets/${$store.getters.currentTheme}/images/leave.png`)" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.exit') }}</span>
                  </div>
                </div>

                <!-- HELP -->
                <div v-if="!isFromKYCVerify" class="game-menu-item link-item" @click="goHelpCenter">
                  <div class="game-menu-item-icon">
                    <img :src="require(`@/assets/${$store.getters.currentTheme}/images/headset.png`)" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.headset') }}<span />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- frame-grid End -->
      </div>
      <!-- game-component End -->
    </div>
  </div>
</template>

<script>
import { gameStart, gameEnd } from '@/utils/games'
import { addFavoriteGame, removeFavoriteGame } from '@/api/user'
import { showToast, handleHelpCenterLink } from '@/utils/tool'
import { mapGetters } from 'vuex'
export default {
  name: 'GameModal',
  props: {
    allGame: {
      type: Array,
      default: () => { return [] }
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      favoriteGames: [],
      isWalletDrawerOpen: false,
      isHistoryDrawerOpen: false,
      isDepositDrawerOpen: false,
      showDetail: false,
      isNewsTickerActive: false,
      newsTickerStyle: {
        left: '0px'
      },
      scrollPosition: 0,
      animationFrameId: null,
      isScrolling: true
    }
  },
  computed: {
    ...mapGetters(['gameIdsArray']),
    gameIdSet() {
      return new Set(this.gameIdsArray.map(gameObj => gameObj.game_id))
    },
    gameUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    user() {
      return this.$store.state.user
    },
    banner() {
      return this.$store.state.brand.banners[0]
    },
    token() {
      return this.$store.getters.token
    },
    filterResult() {
      if (this.gameIdSet.size === 0) { // 沒有遊玩紀錄，顯示全部遊戲
        return this.allGame
      } else { // 顯示遊玩紀錄
        return this.$store.state.game.gameRecords // gamelist API資料
      }
    },
    isFromKYCVerify() {
      return this.user.isFromKYCVerify
    }
  },
  watch: {
    gameUrlFromStore(newVal, oldVal) {
      if (newVal !== oldVal) {
        const headerElement = document.querySelector('header')
        if (newVal) {
          headerElement.style.display = 'none'
          this.disableScrolling()
        } else {
          this.enableScrolling()
          headerElement.style.display = window.innerWidth < 992 ? 'block' : 'none'
        }
      }
    },

    '$store.state.app.gameUrl'(newVal) {
      if (!newVal) {
        gameEnd(this.$store.state.app.inGameId)
      }
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.clearGameUrl)
    this.startScrolling()
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.clearGameUrl)
    this.stopScrolling()
  },

  methods: {
    async handleFavoriteGame(game) {
      const gameInfo = {
        type: 'game',
        data: JSON.stringify([{
          brand_id: this.user.goldInfo.brand_id,
          game_id: game.id
        }])
      }
      try {
        const response = game.isFavorite
          ? await removeFavoriteGame(gameInfo)
          : await addFavoriteGame(gameInfo)

        this.favoriteGames = response.data.data.game
        this.$store.commit('SET_FAVORITE_GAME', this.favoriteGames)
        this.updateGameListLocally(game, !game.isFavorite)
      } catch (error) {
        console.error(error)
      }
    },
    // 顯示彈窗訊息
    showToast(game, isFavorite) {
      const message = isFavorite ? `${game.name} ${this.$t('Bao.favorite')}` : `${game.name} ${this.$t('Bao.favorite_remove')}`
      showToast(message)
      setTimeout(() => {
        this.$store.commit('SET_TOAST_MESSAGE', null)
      }, 3000)
    },
    updateGameListLocally(game, isFavorite) {
      this.showToast(game, isFavorite)
      this.updateFavoriteStatus(game, isFavorite)
    },
    // 點擊愛心後，比對個別遊戲id，增刪“isFavorite” property
    updateFavoriteStatus(game, isFavorite) {
      const updatedGame = {
        ...game,
        isFavorite: isFavorite // Set the isFavorite property to the new value
      }
      this.$store.commit('SET_CURRENT_GAME', updatedGame)
    },

    triggerDetail(game) {
      this.$set(game, 'showDetail', !game.showDetail)
    },
    async handleLaunchGame(game) {
      await gameStart('game', game)
      this.isWalletDrawerOpen = false
      this.isHistoryDrawerOpen = false
      this.isDepositDrawerOpen = false
    },
    scrollGameCardList(direction) {
      const gameCardList = this.$refs.gameCardList
      const scrollAmount = 260

      if (direction === 'right') {
        gameCardList.scrollTop -= 10
        gameCardList.scrollLeft += scrollAmount
      } else {
        gameCardList.scrollTop += 10
        gameCardList.scrollLeft -= scrollAmount
      }
    },
    clearGameUrl() {
      this.$store.commit('SET_KYC_VERIFY', false)
      this.$store.commit('SET_GAME_URL', null)

      this.$store.state.app.tempGameUrl = ''
      this.isWalletDrawerOpen = false
      this.isHistoryDrawerOpen = false
      this.isDepositDrawerOpen = false
    },
    handleDepositClick() {
      this.clearGameUrl()
      this.$router.push('/deposit')
    },
    toggleDrawer(drawerType) {
      if (drawerType === 'wallet') {
        this.isWalletDrawerOpen = !this.isWalletDrawerOpen
        this.isHistoryDrawerOpen = false
        this.isDepositDrawerOpen = false
      } else if (drawerType === 'history') {
        this.isHistoryDrawerOpen = !this.isHistoryDrawerOpen
        this.isWalletDrawerOpen = false
        this.isDepositDrawerOpen = false
      } else if (drawerType === 'deposit') {
        this.isDepositDrawerOpen = !this.isDepositDrawerOpen
        this.isWalletDrawerOpen = false
        this.isHistoryDrawerOpen = false
      }
    },
    disableScrolling() {
    // Disable scrolling
      document.body.style.overflow = 'hidden'
    },
    enableScrolling() {
    // Enable scrolling
      document.body.style.overflow = ''
    },
    toggleNewsTickerActive() {
      this.isNewsTickerActive = !this.isNewsTickerActive
      this.updateNewsTickerPosition()
    },
    updateNewsTickerPosition() {
      if (this.$refs.newsTicker) {
        const width = this.$refs.newsTicker.offsetWidth
        const actualWidth = Math.min(width, 414)
        this.newsTickerStyle.left = this.isNewsTickerActive
          ? `calc(-${actualWidth}px + 25px)`
          : '0px'
      }
    },
    goHelpCenter() {
      const isGuest = !this.token
      const user = this.user
      const userInfo = this.user.memberInfo
      const vipInfo = this.user.vipInfo
      const dateFormatter = this.$options.filters.dateFormat

      handleHelpCenterLink(isGuest, this.banner, user, userInfo, vipInfo, dateFormatter)
    },
    startScrolling() {
      // If scrolling is already disabled, don't start the animation
      if (!this.isScrolling) return

      const scrollText = () => {
        // Stop animation if scrolling is disabled
        if (!this.isScrolling) return

        // Move text 2 pixels to the left each frame
        this.scrollPosition -= 1 // Adjust speed as needed
        const textElement = this.$refs.scrollingText

        if (textElement) {
          // When text scrolls completely off screen (position is less than negative width),
          // reset position to start from right side again
          if (this.scrollPosition <= -textElement.offsetWidth) {
            this.scrollPosition = textElement.parentElement.offsetWidth
          }

          // Apply the horizontal translation to move the text
          textElement.style.transform = `translateX(${this.scrollPosition}px)`
        }

        // Request next animation frame to continue scrolling
        this.animationFrameId = requestAnimationFrame(scrollText)
      }

      // Start the scrolling animation loop
      scrollText()
    },

    stopScrolling() {
      this.isScrolling = false
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId)
      }
    }
  }
}
</script>

<style scoped>
.news-content {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.scrolling-text {
  display: inline-block;
  white-space: nowrap;
}
</style>
